import types from './types';
import { ThunkDispatch } from "redux-thunk";
import api from 'constants/api';
import _get from 'lodash/get';
import { BannerDetail } from 'utils/types';

export const getActiveBannerDetails = (CompanyId: string) => (dispatch: ThunkDispatch<any, any, any>) => {
	CompanyId = CompanyId ==='BA' ? 'BAIPA' : CompanyId;

  dispatch({ type: types.GET_BANNER_DETAILS_REQUEST, payload: CompanyId });

  return api.app.banner.getActiveBannerDetails(CompanyId)
    .then((res: BannerDetail[]) => {

      dispatch({
        type: types.GET_BANNER_DETAILS_SUCCESS,
        payload: res,
      });

      return res;
    })
    .catch((err: Error) => {
      const msg = _get(err, 'response.data.msg', 'Get failed!');
      const errors = _get(err, 'response.data.errors', {});
      const payload = { ...err, msg, errors };

      dispatch({
        type: types.GET_BANNER_DETAILS_FAILURE,
        payload,
      });

      return Promise.reject(payload);
    });
};
